import { CircularProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Alert from '../../utils/Alert';
import { Outlet } from 'react-router-dom';

const DataTablePagination = ({
    tableCols,
    title,
    searchTitle,
    withoutSearch,
    withoutLineNumber,
    children,
    APIFunction,
    dataField,
    hasOutlet,
    outletData,
    hasCatergory,
    categoryOptions,
    forceRequest,
    setForceRequest,
    hasCheckBox,
    hasContractorId,
    contractorId,
    checkBoxes
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [pagesCount, setPagesCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsCnt, setItemsCnt] = useState(20);
    const [searchChar, setSearchChar] = useState("");
    const [category, setCategory] = useState("");
    const [checkBoxesArray, setCheckBoxesArray] = useState(checkBoxes || []);

    const searchInputRef = useRef(null);

    let itemsCountTimeout;
    let searchCharTimeout;

    const handleGetData = async (currentPage, itemsCount, char, cat, checkBoxesArr) => {
        setIsLoading(true);
        let response;
        try {
            if (hasCatergory && hasCheckBox) {
                if (hasContractorId) {
                    response = await APIFunction(currentPage, itemsCount, char, cat, checkBoxesArr, contractorId);
                }else {
                    response = await APIFunction(currentPage, itemsCount, char, cat, checkBoxesArr);
                }
            }else if (hasCatergory) {
                if (hasContractorId) {
                    response = await APIFunction(currentPage, itemsCount, char, cat, contractorId);
                }else {
                    response = await APIFunction(currentPage, itemsCount, char, cat);
                }
            }else if (hasCheckBox) {
                if (hasContractorId) {
                    response = await APIFunction(currentPage, itemsCount, char, checkBoxesArr, contractorId);
                }else {
                    response = await APIFunction(currentPage, itemsCount, char, checkBoxesArr);
                }
            }else {
                if (hasContractorId) {
                    response = await APIFunction(currentPage, itemsCount, char, contractorId);
                }else {
                    response = await APIFunction(currentPage, itemsCount, char);
                }
            }
            if (response.status === 200) {
                setData(response.data[dataField]);
                setPagesCount(response.data.pages);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status !== 500) {
                    Alert(`خطا ${error.response.status}!`, error.message, "error");
                }
            } else {
                Alert("خطا!", error.message, "error");
            }
        } finally {
            setIsLoading(false);
        }
    }

    const handleSetCurrentPage = (ev, page) => {
        setCurrentPage(page);
    }

    const handleSetItemsCnt = (ev) => {
        let cnt = parseInt(ev.target.value);
        if (Number.isNaN(cnt)) {
            cnt = 20;
        } else if (cnt > 20) {
            cnt = 20;
        } else if (cnt < 1) {
            cnt = 1;
        }
        clearTimeout(itemsCountTimeout);
        itemsCountTimeout = setTimeout(() => {
            setItemsCnt(cnt);
        }, 1000);
    }

    const handleSetSearchChar = (ev) => {
        const char = ev.target.value;
        clearTimeout(searchCharTimeout);
        searchCharTimeout = setTimeout(() => {
            setSearchChar(char);
            setCurrentPage(1);
        }, 1000);
    }

    const handleChangeCheckbox = (ev) => {
        const checked = ev.target.checked;
        const value = ev.target.value;
        setCheckBoxesArray(prevValue => prevValue.map(item => {
            return item.value === value ? { ...item, checked } : item;
        }));
    }

    useEffect(() => {
        handleGetData(currentPage, itemsCnt, searchChar, category, checkBoxesArray);
    }, [currentPage, itemsCnt]);

    useEffect(() => {
        setCurrentPage(1);
        handleGetData(1, itemsCnt, searchChar, category, checkBoxesArray);
    }, [searchChar, category, checkBoxesArray]);

    useEffect(() => {
        setCurrentPage(1);
        setSearchChar("");
        setCategory("");
        setCheckBoxesArray(checkBoxes || []);
        handleGetData(1, itemsCnt, "", "", checkBoxes || []);
        if (searchInputRef.current) {
            searchInputRef.current.value = "";
        }
    }, [APIFunction, dataField, forceRequest])

    useEffect(() => {
        if (currentPage > pagesCount) {
            setCurrentPage(1);
        }
    }, [pagesCount]);

    return (
        <>
            <h1 className="ms-1 text-2xl text-center mb-4">
                {title}
            </h1>
            {(children || hasOutlet) && (
                <div className={`my-1 flex justify-between 
                items-center flex-wrap
                ${isLoading ? "pointer-events-none" : ""}`}
                >
                    {children}
                    {hasOutlet && (
                        <Outlet
                            context={{
                                dataLength: data.length,
                                setData,
                                itemsCnt,
                                setForceRequest,
                                ...outletData
                            }}
                        />
                    )}
                </div>
            )}
            {(hasCatergory || hasCheckBox) && (
                <div className={`flex justify-start items-center flex-wrap gap-4
                mt-2 mb-4 ${isLoading ? "pointer-events-none" : ""}`}>
                    {hasCatergory && (
                        <div>
                            <select
                                value={category}
                                onChange={(ev) => setCategory(ev.target.value)}
                                className="w-52 px-2 py-1
                     bg-transparent border-2 rounded-lg 
                     cursor-pointer"
                            >
                                {categoryOptions.map((opt, index) => (
                                    <option
                                        key={`status_${opt.value}_${index}`}
                                        value={opt.value}
                                    >
                                        {opt.text}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    {hasCheckBox && (
                        <div className="flex items-center flex-wrap gap-3">
                            {checkBoxesArray.map((item, index) => (
                                <div
                                    key={`checkbox_${index}_${item.value}`}
                                    className="flex items-center gap-1"
                                >
                                    <input
                                        type="checkbox"
                                        id={item.value}
                                        name={item.value}
                                        value={item.value}
                                        checked={item.checked}
                                        onChange={(ev) => handleChangeCheckbox(ev)}
                                    />
                                    <label htmlFor={item.value}>{item.label}</label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
            <div
                className={`flex items-center 
                flex-wrap mb-5 
                ${withoutSearch ? "justify-end" : "justify-between"}
                ${isLoading ? "pointer-events-none" : ""}`}>
                {!withoutSearch && (
                    <input type="text"
                        className="border-2 rounded-md 
                        outline-none w-72 px-2 py-1 mb-2 me-2"
                        placeholder={`جست و جو ${searchTitle ? `(${searchTitle})` : ""}`}
                        // value={searchChar}
                        onChange={(ev) => handleSetSearchChar(ev)}
                        ref={searchInputRef}
                    />
                )}
                {!withoutLineNumber && 
                    <Tooltip
                        title={currentPage === 1 ? "تعداد سطرهای جدول (1 تا 20)" : "فقط در صفحه‌ی اول امکان تغییر تعداد سطرها وجود دارد"}
                        arrow={true}
                        placement="bottom"
                    >
                        <input type="number"
                            className={`border-2 rounded-md 
                            outline-none w-52 px-2 py-1 mb-2
                            ${currentPage > 1 ? "bg-gray-200 text-gray-500" : ""}`}
                            // min="1" max="20"
                            // value={itemsCnt}
                            placeholder="تعداد سطرها"
                            onChange={(ev) => handleSetItemsCnt(ev)}
                            disabled={currentPage > 1}
                        />
                    </Tooltip>
                }
            </div>
            <TableContainer component={Paper}
                sx={{
                    overflowX: "auto",
                    mb: 4,
                    borderRadius: "10px"
                }}
                elevation={5}
            >
                {isLoading ? (
                    <div className="w-full flex flex-col 
                    items-center justify-center
                    px-3 py-10">
                        <CircularProgress size={50} />
                        <span className="text-primary mt-4 
                        text-xl opacity-animation">
                            صبر کنید...
                        </span>
                    </div>
                ) : data.length > 0 ? (
                    <Table sx={{ minWidth: "600px" }}>
                        <TableHead className="border-b-2 border-black">
                            <TableRow>
                                {tableCols.map((col, index) => (
                                    <TableCell
                                        key={`${Math.random()}_${index}`}
                                        align="center"
                                    >
                                        {col.text}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((data, index) => (
                                <TableRow
                                    key={`${Math.random()}_${index}`}
                                    className="[&:nth-child(2n+1)]:bg-gray-100"
                                >
                                    {tableCols.map((col, index) => (
                                        <TableCell
                                            key={`${Math.random()}_${index}`}
                                            align="center"
                                        >
                                            {col.field ? data[col.field] : col.element(data)}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <div className="w-full px-3 py-10 
                    text-center text-red-500 text-xl">
                        هیچ نتیجه ای یافت نشد!
                    </div>
                )}
            </TableContainer>
            {pagesCount > 1 && (
                <div className={`children-dir-ltr mt-8 w-full
                  flex justify-center items-center
                  ${isLoading ? "pointer-events-none" : ""}`}>
                    <Pagination
                        count={pagesCount}
                        page={currentPage}
                        boundaryCount={1}
                        onChange={(ev, page) => handleSetCurrentPage(ev, page)}
                        color="primary"
                    />
                </div>
            )}
        </>
    );
}

export default DataTablePagination;
